import { Box, Flex, Text } from '@chakra-ui/react';
import { faWarning } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@morressier/alembic';
import _ from 'lodash';
import { useNavigate } from 'react-router-dom';

const MissingInformationActionBanner = ({
  missingFieldNames
}: {
  missingFieldNames: string[];
}) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate('/app/account');
  };
  return (
    <Flex
      flexDirection="column"
      gap={8}
      textAlign="left"
      marginX="auto"
      padding={4}
      width={'100%'}
    >
      <Box
        bgColor={'errorPrimaryFill'}
        padding={10}
        textAlign="center"
        color={'actionSecondaryCautionContent'}
        borderRadius={8}
      >
        <FontAwesomeIcon icon={faWarning} fontSize={40} />
      </Box>
      <Flex flexDirection="column" gap={2}>
        <Flex
          direction={'column'}
          alignItems={'center'}
          textAlign={'center'}
          gap={8}
        >
          <Flex direction="column" gap={3}>
            <Text textStyle="headingTitle">
              Action Required: Complete Your Author Details
            </Text>
            <Text textStyle={'textBody'}>
              Before you can proceed with the submission, please{' '}
              <strong>
                {' '}
                fill in your{' '}
                {`${_.join(_.initial(missingFieldNames), ', ')} and ${_.last(
                  missingFieldNames
                )}`}{' '}
              </strong>{' '}
              for your profile. This information is required to ensure proper
              indexing and identification of your work.
            </Text>
          </Flex>
          <Button onClick={handleNavigate}>Update My Profile</Button>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default MissingInformationActionBanner;
